import { render, staticRenderFns } from "./SiteHeaderComponent.vue?vue&type=template&id=68be075b&scoped=true"
import script from "./SiteHeaderComponent.vue?vue&type=script&lang=js"
export * from "./SiteHeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./SiteHeaderComponent.vue?vue&type=style&index=0&id=68be075b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be075b",
  null
  
)

export default component.exports